// API configuration for different environments
export const API_CONFIG = {
  // Backend API URL - can be overridden by environment variables
  BASE_URL: process.env.REACT_APP_API_URL || 'https://rishi-personal-website-backend.onrender.com',
  
  // API endpoints
  ENDPOINTS: {
    CHAT: '/api/chat',
    CHAT_HISTORY: '/api/chat/history',
    CHAT_END: '/api/chat/end',
    CHAT_CLEAR: '/api/chat/clear',
    CONTACT: '/api/contact',
  },
  
  // Session configuration
  SESSION: {
    // Whether to use credentials (cookies) for same-domain requests
    USE_CREDENTIALS: true,
    // Header name for session ID in cross-domain requests
    SESSION_HEADER: 'x-session-id',
  }
}
